import React, { Component } from 'react';
import { Row, Col, Table, PanelGroup, Panel } from "react-bootstrap";
import { toast } from 'react-toastify';

import { CustomCard } from "../../../components/Card/CustomCard";

import { BusquedaEstInd } from "../../../funciones/CobranzasFunction";
import { ConsultCuentaAdmin } from "../../../funciones/EstCuentaFunction";

import EstCuentaTable from "../EstadosCuentaContent/EstCuentaTable";

import { AgregarCobro } from '../../../funciones/AdministracionFunction';
import { formatNumber, formatReconver } from "../../../funciones/GeneralFunctions";

let detalleEst = "";
let detalleEstHIst = [];
class CobroEspecial extends Component {
    state = {
        string: "",
        icon2: "",
        listEst: [],
        preloaderI: {
            icon: "",
            text: "Ingresa la Cédula, el nombre o el apellido del estudiante para buscar"
        },
        boton: {
            icon: "fa fa-plus",
            text: "Aplicar Cobro",
            disabled: false
        },
        concepto: "",
        valor: "",
        iconChevron3: "fa fa-chevron-down",
        btnDown3: true,
    }

    cambiaValor = (prop) => (e) => {
        this.setState({
            [prop]: (e.target.value).toUpperCase()
        })
    }

    cambiaIcon = (btn, icon, content) => {
        this.setState ({
            [btn]: !this.state[btn],
            [content]:!this.state[content],
        }, () => {
            (this.state[btn] === true) ? this.setState({[icon]: "fa fa-chevron-down"}) : this.setState({[icon]: "fa fa-chevron-up"})
        })
    }

    cambiaValorNum = (prop) => (e) => {
        /* if (!isNaN(Number(e.target.value)) === false) return null; */

        this.setState({
            [prop]: e.target.value
        })
    }

    busquedaEst = () => (e) => {
        if (e.which === 13){
            detalleEst = ""
            this.setState ({
                icon2: "fa fa-spinner fa-spin",
                preloaderI: {
                    icon: "fa fa-spinner fa-spin",
                    text: "Buscando estudiantes, espera"
                },
            }, () => {
                BusquedaEstInd (this.state.string, (resp) => {
                    let prel = { icon: "", text: "" };
                    if (resp.length === 0) prel = { icon: "", text: "No existen coincidencias con la búsqueda seleccionada" };

                    this.setState({
                        listEst: resp,
                        icon2: "",
                        preloaderI: prel,
                    })
                })
            })
        }
    }

    aplicarCobro = () => {
        let { concepto, valor, boton, string } = this.state;

        if (boton.disabled === true) return null;

        if (concepto === ""){
            toast.error("Debes indicar el concepto del cobro",{autoClose: 4000});
        }else if (valor === ""){
            toast.error("Debes indicar el monto del cobro",{autoClose: 4000});
        }else{
            this.setState({
                boton: {
                    icon: "fa fa-spinner fa-spin",
                    text: "Espera",
                    disabled: true
                }
            }, () => {
                AgregarCobro (detalleEst[1].id, concepto, valor, () => {
                    BusquedaEstInd (string, (resp) => {
                        let prel = { icon: "", text: "" };
                        if (resp.length === 0) prel = { icon: "", text: "No existen coincidencias con la búsqueda seleccionada" };
    
                        this.setState({
                            listEst: resp,
                            icon2: "",
                            preloaderI: prel,
                        })
                    })

                    ConsultCuentaAdmin (detalleEst[1].id, (resp)=> {
                        let respuesta = resp;
                        detalleEst = [respuesta, detalleEst[1]]
                        this.setState({
                            boton1: {
                                icon: "fa fa-money",
                                text: "Cuenta",
                                disabled: false
                            },
                            boton: {
                                icon: "fa fa-plus",
                                text: "Aplicar Cobro",
                                disabled: false
                            },
                            concepto: "",
                            valor: ""
                        }, () => {
                            toast.info("Se le a aplicado el cobro al estudiante correctamente. Le hemos enviado una notificación de cobro",{autoClose: 4000});
                        })
                    })
                })
            })
        }
    }

    contenido = () => {
        let { string, icon2, listEst,preloaderI, boton, concepto, valor, estadosHist, iconChevron3 } = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        const stylesBs = {
            padding: 3, fontSize: 10
        }

        let tablaEst = () => {
            if (listEst.length === 0) return (<div align="center" className="text-danger"><i className={preloaderI.icon}></i> {preloaderI.text}</div>)

            return (
                <div className="table-responsive" style={{overflowY: "auto", maxHeight: "25vh", backgroundColor: "#FFF", border: "1px solid #1f2f6e"}}>
                    <Table striped hover bordered>
                        <tbody>
                            <tr className="custon-back-color">
                                <td width="45%" style={styles}><strong>Estudiante</strong></td>
                                <td width="35%" align="center" style={styles}><strong>Carrera</strong></td>
                                <td width="20%" align="center" style={styles}><strong>Estado</strong></td>
                                <td width="200px" align="center" style={styles}><strong>Acciones</strong></td>
                            </tr>
                            {listEst.map (option => (
                                <EstCuentaTable key={option.id} datos={option}
                                    Detalles={(datos) => {
                                        detalleEst = datos;
                                        detalleEstHIst = datos[2];
                                        this.setState({control: !this.state.control})
                                    }}
                                />
                            ))}
                        </tbody>
                    </Table>
                </div>
            )
        }

        let contentEstado = () => {
            if (detalleEst[0].length === 0) return (
                <tr>
                    <td colSpan={7} align="center">No existen asientos disponibles</td>
                </tr>
            )

            let bs = (monto) => {
                let bs = `${formatNumber(monto)}`;
                let bsConv = `${formatReconver(monto)}`;

                if (monto === "" || monto === null) bs = "";

                return (
                    <React.Fragment>
                        <div>{bs}</div>
                        {/* <div className = "text-danger" style = {{fontWeight: "bold"}}>{bsConv}</div> */}
                    </React.Fragment>
                )
            }

            let icono = (mess, status) => {
                let icono = <i className="fa fa-check-circle text-success"></i>;
                if (status === "0") icono = <i className="fa fa-exclamation-triangle text-warning"></i>;
                if (mess === "Error") icono = <i className="fa fa-times-circle text-danger"></i>;

                return icono;
            }

            let status = (mess, status) => {
                let styles = {color:"#000"}
                if (status === "0") styles = {backgroundColor: "#f8f2ee", color:"#a80012", cursor:"pointer"}
                if (mess === "Error") styles = {backgroundColor: "#fff4f6", color:"#A0555C", cursor:"pointer"}

                return styles;
            }

            let aviso = (mess, status) => {
                let aviso = "";
                if (status === "0") aviso = "Esta transacción está pendiente de aprobación";
                if (mess === "Error") aviso = "Esta transacción presenta un problema. Ponte en contacto con Administración";

                return aviso;
            }

            return (
                detalleEst[0].map(option => (
                    <tr key = {option.num} style={status(option.resultado, option.status)} title ={aviso(option.resultado, option.status)}>
                        <td align="center" style={{padding: 5, fontSize: 10}}>{option.num}</td>
                        <td align="center" style={{padding: 5, fontSize: 10}}>{option.fecha}</td>
                        <td style={{padding: 5, fontSize: 10}}>{option.descripcion}</td>
                        <td align="center" style={stylesBs}>{bs(option.debe)}</td>
                        <td align="center" style={stylesBs}>{bs(option.haber)}</td>
                        <td align="center" style={stylesBs}>
                            {formatNumber(option.saldo)}
                            {/* <div className = "text-danger" style = {{fontWeight: "bold"}}>{formatReconver(option.saldo)}</div> */}
                        </td>
                        <td align="center" style={styles}>{icono(option.resultado, option.status)}</td>
                    </tr>
                ))
            )
        }

        let contentEstadoHist = () => {
            if (detalleEstHIst.length === 0) return (
                <tr>
                    <td colSpan={7} align="center">No existen asientos históricos disponibles</td>
                </tr>
            )

            let bs = (monto) => {
                let bs = `${formatNumber(monto)}`;
                let bsConv = `${formatReconver(monto)}`;
                
                if (monto === "" || monto === null) bs = "";
                return (
                    <React.Fragment>
                        <div>{bs}</div>
                        {/* <div className = "text-danger" style = {{fontWeight: "bold"}}>{bsConv}</div> */}
                    </React.Fragment>
                )
            }

            let icono = (mess, status) => {
                let icono = <i className="fa fa-check-circle text-success"></i>;
                if (status === "0") icono = <i className="fa fa-exclamation-triangle text-warning"></i>;
                if (mess === "Error") icono = <i className="fa fa-times-circle text-danger"></i>;

                return icono;
            }

            let status = (mess, status) => {
                let styles = {color:"#000"}
                if (status === "0") styles = {backgroundColor: "#f8f2ee", color:"#a80012", cursor:"pointer"}
                if (mess === "Error") styles = {backgroundColor: "#fff4f6", color:"#A0555C", cursor:"pointer"}

                return styles;
            }

            let aviso = (mess, status) => {
                let aviso = "";
                if (status === "0") aviso = "Esta transacción está pendiente de aprobación";
                if (mess === "Error") aviso = "Esta transacción presenta un problema. Ponte en contacto con Administración";

                return aviso;
            }

            let num = 0
            return (
                detalleEstHIst.map(option => {
                    num++;
                    return(
                        <tr key = {option.num} style={status(option.resultado, option.status)} title ={aviso(option.resultado, option.status)}>
                            <td align="center" style={{padding: 5, fontSize: 10}}>{option.num}</td>
                            <td align="center" style={{padding: 5, fontSize: 10}}>{option.fecha}</td>
                            <td style={{padding: 5, fontSize: 10}}>{option.descripcion}</td>
                            <td align="center" style={stylesBs}>{bs(option.debe)}</td>
                            <td align="center" style={stylesBs}>{bs(option.haber)}</td>
                            <td align="center" style={stylesBs}>
                                {formatNumber(option.saldo)}
                                {/* <div className = "text-danger" style = {{fontWeight: "bold"}}>{formatReconver(option.saldo)}</div> */}
                            </td>
                            <td align="center" style={styles}>{icono(option.resultado, option.status)}</td>
                        </tr>
                    )
                })
            )
        }

        let histAsientos = () => {
            if (detalleEstHIst.length === 0) return null;

            return(
                <PanelGroup accordion activeKey={estadosHist} className="custom-alert-danger">
                    <Panel eventKey = {true}>
                        <Panel.Heading onClick = {()=> {this.cambiaIcon( "btnDown3", "iconChevron3", "estadosHist")}}>
                            <Panel.Title toggle className="text-danger">
                                <Row>
                                    <Col md={10} style={{fontSize: 12}}>
                                        <strong><i className="fa fa-calendar"></i> Histórico de Asientos</strong>
                                    </Col>
                                    <Col md={2} align="right">
                                        <i className={iconChevron3}></i>
                                    </Col>
                                </Row>
                            </Panel.Title>
                        </Panel.Heading>
                        <Panel.Body collapsible style={{paddingTop:10}}>
                            <div className="table-responsive" style={{overflowY: "auto", maxHeight:"45vh", backgroundColor: "#FFF", border: "1px solid #1f2f6e"}}>
                                <Table striped hover bordered style={{marginBottom: 0}}>
                                    <tbody>
                                        <tr className="custon-back-color">
                                            <td width="10%" align="center" style={styles}><strong>N°</strong></td>
                                            <td width="10%" align="center" style={styles}><strong>Fecha</strong></td>
                                            <td width="40%" style={styles}><strong>Descripción</strong></td>
                                            <td width="12%" align="center" style={stylesBs}><strong>Facturado Bs.</strong></td>
                                            <td width="12%" align="center" style={stylesBs}><strong>Pagado Bs.</strong></td>
                                            <td width="16%" align="center" style={stylesBs}><strong>Balance Bs.</strong></td>
                                            <td width="30px" align="center" style={styles}></td>
                                        </tr>
                                        {contentEstadoHist()}
                                    </tbody>
                                </Table>
                            </div>
                        </Panel.Body>
                    </Panel>
                </PanelGroup>
            )
        }

        let detalles = () => {
            if (listEst.length === 0) return null;
            if (detalleEst === "") return (<div className="text-danger custom-mt-10" align="center">Selecciona un Estudiante para revisar su Estado de Cuenta</div>)

            return (
                <React.Fragment>
                    <div className="custom-alert-info custom-mt-10" style={{padding: 5}}>
                        Estado de Cuenta de <strong>{detalleEst[1].Estudiante}</strong>
                    </div>
                    <Row className="custom-mt-10">
                        <Col md={6}><span className="text-danger">Carrera:</span> <strong>{detalleEst[1].Carrera}</strong></Col>
                        <Col md={6} align="right"><span className="text-danger">Deuda:</span> <strong>{detalleEst[1].Deuda}</strong></Col>
                    </Row>
                    {histAsientos()}
                    <div className="table-responsive" style={{overflowY: "auto", maxHeight:"45vh", backgroundColor: "#FFF", border: "1px solid #1f2f6e"}}>
                        <Table striped hover bordered style={{marginBottom: 0}}>
                            <tbody>
                                <tr className="custon-back-color">
                                    <td width="10%" align="center" style={styles}><strong>N°</strong></td>
                                    <td width="10%" align="center" style={styles}><strong>Fecha</strong></td>
                                    <td width="40%" style={styles}><strong>Descripción</strong></td>
                                    <td width="12%" align="center" style={stylesBs}><strong>Facturado Bs.</strong></td>
                                    <td width="12%" align="center" style={stylesBs}><strong>Pagado Bs.</strong></td>
                                    <td width="16%" align="center" style={stylesBs}><strong>Balance Bs.</strong></td>
                                    <td width="30px" align="center" style={styles}></td>
                                </tr>
                                {contentEstado()}
                            </tbody>
                        </Table>
                    </div>
                    <div className="custom-alert-danger custom-mt-10"><i className="fa fa-money"></i> Opciones de Cobro</div>
                    <Row className="custom-mt-10">
                        <Col md={6}>
                            <input type="text" value={concepto} onChange={this.cambiaValor("concepto")} placeholder="Concepto" className="form-control"/>
                            <span className="text-muted" style={{fontSize: 10}}>* Concepto</span>
                        </Col>
                        <Col md={3}>
                            <input type="number" value={valor} onChange={this.cambiaValorNum("valor")} placeholder="Monto en Bs." className="form-control"/>
                            <span className="text-muted" style={{fontSize: 10}}>* Monto en Bolívares</span>
                        </Col>
                        <Col md={3} align="right">
                            <button className="btn btn-danger" onClick={this.aplicarCobro} title="Aplicar cobro al estudiante" style={{borderWidth: 1}}><i className={boton.icon}></i> {boton.text}</button>
                        </Col>
                    </Row>
                </React.Fragment>
            )
        }

        return(
            <React.Fragment>
                <div className="custom-alert-info">
                    Búsqueda de Estudiantes <i className={icon2}></i>
                    <input type="text" className="form-control" onKeyPress={this.busquedaEst()} value={string} onChange={this.cambiaValor("string")} placeholder="Ingresa la C.I., nombre o apellido del estudiante"/>
                </div>
                <div className="custom-mt-10">{tablaEst()}</div>
                <div className="custom-mt-10">{detalles()}</div>
            </React.Fragment>
        )
    }

    ayuda = () => (
        <Row>
            <Col md={12} align="justify">
                En esta sección puedes aplicar <span className="text-primary"><strong>Cobro de Cuotas Extraordinarias</strong></span> de los estudiantes. Para esto debes relizar los siguientes pasos:
            </Col>
            <Col md={12} className="text-primary custom-mt-10"><strong>Paso 1</strong></Col>
            <Col md={12} align="justify">
                Ingresa la cédula, el nombre o el apellido en el buscador. Esto te mostrará los resultados obtenidos
            </Col>
            <Col md={12} className="text-primary custom-mt-10"><strong>Paso 2</strong></Col>
            <Col md={12} align="justify">
                Selecciona un estudiante y presiona el botón <button className="btn btn-primary btn-xs" style={{borderWidth: 1}}><i className="fa fa-money"></i> Cuenta</button> para ver el estado de cuenta del estudiante
            </Col>
            <Col md={12} className="text-primary custom-mt-10"><strong>Paso 3</strong></Col>
            <Col md={12} align="justify">
                En la sección <span className="custom-alert-danger"><i className="fa fa-money"></i> Opciones de Cobro</span> ingresa el concepto del cobro a aplicar y el monto y luego presiona el botón <button className="btn btn-danger btn-xs" style={{borderWidth: 1}}><i className="fa fa-money"></i> Aplicar Cobro</button>
            </Col>
        </Row>
    )

    render() { 
        return (
            <div className="content">
                <Row>
                    <Col md={8}>
                        {this.contenido()}
                    </Col>
                    <Col md={4}>
                        <div style={{borderRadius: "4px 4px",}}>
                            <CustomCard
                                styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                category={<span style={{color: "#fff"}}>Cobros Especiales</span>}
                                color="#a80012"
                                content={this.ayuda()}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}
 
export default CobroEspecial;


// WEBPACK FOOTER //
// ./src/views/Administracion/CobranzasContent/CobroEspecial.jsx